import { encryptData, decryptData } from "./data-encryption";
import Cookies from "js-cookie";

export function setItem(key, value) {
  const encrypted = encryptData(JSON.stringify(value));

  if (key === "permissions") {
    localStorage.setItem(key, encrypted);
  } else {
    Cookies.set(key, encrypted, {
      expires: 1,
      path: "/",
      secure: true,
      sameSite: "Strict",
    });
  }
}

export function getItem(key) {
  let encrypted;

  if (key === "permissions") {
    encrypted = localStorage.getItem(key);
  } else {
    encrypted = Cookies.get(key);
  }

  if (!encrypted) return null;

  try {
    return JSON.parse(decryptData(encrypted));
  } catch (e) {
    console.error(`Error decrypting data for key "${key}":`, e);
    return null;
  }
}

export function removeItem(key) {
  if (key === "permissions") {
    localStorage.removeItem(key);
  } else {
    Cookies.remove(key);
  }
}
